<div class="container py-4 py-md-5">
    <div class="row mb-4 g-2 align-items-end">

        @if(!isLoggedIn){
        <div class="col-12 col-md-4">
            <select class="form-select" [(ngModel)]="eligibility">
                <option value="">Todos</option>
                <option value="company">Empresas</option>
                <option value="candidate">Candidatos</option>
                <option value="freelance">Profesionales independientes</option>
            </select>
        </div>
        }

        @if(isLoggedIn && roleId == userRole.Member){
        <div class="col-12 col-md-4">
            <select class="form-select" [(ngModel)]="eligibility">
                <option value="">Todos</option>
                <option value="candidate">Candidatos</option>
                <option value="freelance">Profesionales independientes</option>
            </select>
        </div>
        }


        <div class="col-12 col-md-4">
            <select class="form-select" [(ngModel)]="functionalType">
                <option [ngValue]="undefined">Todos los tipos</option>
                <option *ngFor="let t of functionalTypeOptions" [ngValue]="t.id">
                    {{ t.text }}
                </option>
            </select>
        </div>

        <div class="col-12 col-md-4 text-md-end">
            <button type="button" class="btn btn-outline-secondary me-2" (click)="clearFilters()">
                <i class="fa-solid fa-broom"></i> Limpiar
            </button>
            <button type="button" class="btn btn-primary" (click)="applyFilters()">
                <i class="fa-solid fa-filter"></i> Aplicar Filtros
            </button>
        </div>
    </div>

    <div class="row">
        <div *ngFor="let item of items" class="col-12 col-md-6 col-lg-4 mb-4">
            <div class="catalog-card h-100 rounded-4 shadow-sm">
                <img *ngIf="item.coverFileId" class="card-img-top rounded-top-4"
                    [src]="fileBaseUrl + '/' + item.coverFileId" onerror="this.src='assets/Images/No-image-found.jpg'; this.error=null;" [alt]="item.title" loading="lazy">

                <div class="p-3 card-body-flex">
                    <div class="card-header-flex">
                        <h5 class="fw-bold">{{ item.title }}</h5>
                        <h6 class="subtitle text-secondary mb-2">{{ item.subtitle }}</h6>
                        <p class="text-muted mb-2">{{ item.shortDescription }}</p>
                    </div>

                    <div class="eligibility-footer">
                        <span *ngIf="item.eligibleCompany && (!isLoggedIn)" class="eligibility-badge company me-2">Empresas</span>
                        <span *ngIf="item.eligibleCandidate" class="eligibility-badge candidate me-2">Candidatos</span>
                        <span *ngIf="item.eligibleFreelance" class="eligibility-badge freelance">Profesionales independientes</span>
                    </div>

                    <div class="d-flex align-items-center justify-content-between mt-2 price-footer">
                        <div class="price fw-semibold">
                            <ng-container *ngIf="item.basePrice != null; else noPrice">
                                {{ item.basePrice | currency }}
                                <small *ngIf="item.appliesITBIS" class="text-muted">+ ITBIS</small>
                            </ng-container>
                            <ng-template #noPrice>
                                <span class="text-muted">—</span>
                            </ng-template>
                        </div>
                        <button class="btn btn-primary" (click)="viewDetail(item)">
                            {{ item.preApprovalRequired ? 'Solicitar' : 'Comprar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="loading && items.length === 0">
            <div class="col-12 col-md-6 col-lg-4 mb-4" *ngFor="let sk of [1,2,3,4,5,6]">
                <div class="catalog-card h-100 rounded-4 shadow-sm skeleton-card">
                    <div class="skeleton skeleton-img"></div>

                    <div class="p-3 card-body-flex">
                        <div class="card-header-flex">
                            <div class="skeleton skeleton-text w-75 mb-2"></div>
                            <div class="skeleton skeleton-text w-50 mb-2"></div>
                            <div class="skeleton skeleton-text w-100 mb-2"></div>
                            <div class="skeleton skeleton-text w-75 mb-3"></div>
                        </div>

                        <div class="eligibility-footer">
                            <div class="skeleton skeleton-badge"></div>
                        </div>

                        <div class="d-flex align-items-center justify-content-between mt-2 price-footer">
                            <div class="skeleton skeleton-text w-25"></div>
                            <div class="skeleton skeleton-btn"></div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>

    <div #infiniteAnchor class="infinite-anchor"></div>

    <div class="text-center py-3">
        <div *ngIf="loading && items.length > 0" class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>

    <div class="modal fade" id="catalogDetail" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable modal-fullscreen-md-down">
            <div class="modal-content rounded-4">
                <div class="modal-body p-4">
                    <app-public-catalog-detail [item]="selectedItem"></app-public-catalog-detail>
                </div>
            </div>
        </div>
    </div>
</div>